import layout from './NavigationItem.html?raw';
import Control from "@/Controls/Control";
import ComponentManager from "@/Management/ComponentManager";
import NavigationItemViewModel from "@/Components/CoreFrameNavigation/NavigationItem/NavigationItemViewModel";
import LocatorHelper from "@/Utility/LocatorHelper";

export default class NavigationItem extends Control {
    private jQueryControl: JQuery;

    public constructor(private viewModel: NavigationItemViewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.applyTemplate(layout, this.jQueryControl, () => {
            this.widget(null);
        });
        
        this.addNativeEventHandler('pointerup', this.jQueryControl[0], (evt) => {
            evt.stopPropagation();

            if (this.isDisposed || !this.viewModel.isEnabled())
                return;

            // Das 'pointerup'-Event verhält sich etwas anders als 'click', daher sichern wir auch einmal auf die Icons ab
            const target = evt.target as HTMLElement;
            const targetElementUpper = target?.tagName.toUpperCase();
            if (targetElementUpper === 'SVG' || targetElementUpper === 'PATH')
                return;

            // Klick auf "falsche" Elemente absichern, um korrekte Navigation zu ermöglichen
            const targetClassList = (evt.target as HTMLElement).classList;
            if (targetClassList?.contains('navigation-wrapper') || targetClassList?.contains('sub-nodes'))
                return;

            this.viewModel.onItemClick();
        }, true);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget) {
        this.applyBindings(this.jQueryControl, {
            controlName: 'navigationitem',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];
                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    const states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    if (this.viewModel.isNodeExpanded() === true) {
                        states.push('expanded');
                    } else {
                        states.push('not-expanded');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(this.jQueryControl.find('.navigation-node'), {
            states: this.definePureComputed({
                read: () => {
                    const states = [];

                    if (this.viewModel.isSelected()) {
                        states.push('selected');
                    } else {
                        states.push('notselected');
                    }
                    
                    if (this.viewModel.hasAction()) {
                        states.push('pointer-active');
                    } else {
                        states.push('pointer-inactive');
                    }

                    return states;
                }
            })
        });
        
        if (this.viewModel.isNodeExpandable()) {
            this.applyBindings(this.jQueryControl.find('.expand-node-wrapper'), {
                locator: LocatorHelper.buildLocator(this.viewModel.locator, 'treeitem-toggle'),
                attr: {
                    'aria-expanded': this.defineComputed(() => {
                        const isExpanded = this.viewModel.isNodeExpanded();
                        
                        return isExpanded ? 'true' : 'false';
                    })
                }
            });
        }
        
        const icon = this.jQueryControl.find('.expand-node-wrapper');
        if (!icon || icon.length === 0)
            return;

        this.addNativeEventHandler('click', icon[0], (evt) => {
            evt.stopPropagation();
            const expanded = this.viewModel.isNodeExpanded();
            this.viewModel.recentExpandedState(!expanded);
            this.viewModel.isNodeExpanded(!expanded);
        }, true);
    }
}

ComponentManager.setControl('NavigationItem', NavigationItem, 'RADPresentation.HTMLClient.DefaultViewExtensions')